module.exports = __webpack_public_path__ + "static/media/Janna_0.4bb9ed1b.jpg";